<template>
    <div class="hall-cover">
        <div class="hall-item flex-shrink-0"
            :class="{ 'hall-item-winning': winningSectors && winningSectors.includes(table.name) }"
            v-for="(table, j) in tables" :key="j" :data-area="table.name" @click="handleAreaClick(table.name)">
            <!-- 卡牌区域 -->
            <div class="pocker">
                <PokerCard v-for="(card, index) in sectorCards[table.name]" :key="index"
                    :ref="(el) => setAreaCardRef(j, index, el as HTMLElement)" :class="{
                        'pocker-img0': index === 0,
                        'pocker-img1': index === 1,
                        'pocker-img2': index === 2,
                        'pocker-img3': index === 3,
                        'pocker-img4': index === 4,

                    }" :card="card" width="3.125rem" height="3.125rem"
                    :isFaceUpProp="isFaceUpProp" />
            </div>

            <!-- 下注区域 -->
            <div class="betting-area" :data-area="table.name"></div>

            <!-- 统计信息浮层 -->
            <div class="betting-area-stats" v-if="props.areaTotalValues && getAreaTotalValue(table.name) > 0">
                <span class="betting-total-amount">{{ getAreaTotalValue(table.name) }}</span>
            </div>

            <!-- 下注结算 -->
            <transition name="betting-result-slide">
                <div class="betting-result" v-if="handTypes && handTypes[table.name]">
                    <div class="relative">
                        <div class="betting-result-content" :class="getBettingResultClass(handTypes?.[table.name])">
                            <!-- 特殊牌型特殊处理UI 五花牛/四炸/五小牛-->
                            <div v-if="handTypes[table.name] == '五花牛' || handTypes[table.name] == '四炸' || handTypes[table.name] == '五小牛'"
                                class="result !text-[1.125rem]">
                                {{ handTypes[table.name] }}
                            </div>
                            <div v-else-if="handTypes[table.name] == 'Five Picture'"
                                class="result !text-[0.813rem] !leading-[0.875rem] flex flex-col item-center justify-center text-center">
                                <span>Five</span>
                                <span>Picture</span>
                            </div>
                            <div v-else-if="handTypes[table.name] == 'Four of a Kind'"
                                class="result !text-[0.813rem] !leading-[0.875rem] flex flex-col item-center justify-center text-center">
                                <span>Four</span>
                                <span>Kind</span>
                            </div>
                            <div v-else-if="handTypes[table.name] == 'Five Small Cards'"
                                class="result !text-[0.813rem] !leading-[0.875rem] flex flex-col item-center justify-center text-center">
                                <span>Five</span>
                                <span>Small</span>
                            </div>
                            <div v-else-if="handTypes[table.name] == 'Bull Bull'"
                                class="result !text-[0.813rem] !leading-[0.875rem] flex flex-col item-center justify-center text-center">
                                <span>Bull</span>
                                <span>Bull</span>
                            </div>
                            <div v-else class="result" :class="[
                                locale == 'cn' ? '!text-[1.25rem]' : '!text-[0.875rem] !leading-[0.75rem]',
                                locale == 'en' && handTypes[table.name] === 'Bull Bull' ? 'whitespace-pre-line' : ''
                            ]">{{ handTypes[table.name] }}</div>

                            <div class="multiple"
                                v-if="handTypes[table.name] && handTypes[table.name] !== $t('niuniu.niuType0')">X{{
                                    multipliers[table.name] }}</div>

                        </div>
                        <!-- 背景雾图 -->
                        <img :src="getHandTypeBgImage(handTypes[table.name])" class="hand-type-bg-fog" alt="">
                    </div>
                </div>
            </transition>

            <!-- 区域信息 -->
            <div>
                <!-- 牌型标签 -->
                <div class="tabs">
                    <div class="tabs-item" :class="tab.typeId != 0 ? 'tabs-item-active' : ''"
                        v-for="(tab, tabIdx) in lastRoundResult[table.name]" :key="tabIdx">
                        <!-- 五花牛 -->
                        <div v-if="tab.typeId == 11"
                            class="text-[0.563rem] font-[600] leading-[0.75rem] flex flex-col items-center justify-start text-center">
                            <template v-if="locale == 'cn'">
                                <div>五</div>
                                <div>花</div>
                            </template>
                            <template v-else>
                                <div>5</div>
                                <IconSvgUse use="icon-flower-red" size="1rem" />
                            </template>
                        </div>
                        <!-- 四炸 -->
                        <div v-else-if="tab.typeId == 12"
                            class="text-[0.563rem] font-[600] leading-[0.75rem] flex flex-col items-center justify-start text-center"
                            style="width:max-content;">
                            <template v-if="locale == 'cn'">
                                <div>四</div>
                                <div>炸</div>
                            </template>
                            <template v-else>
                                <div>F</div>
                                <div>k</div>
                            </template>
                        </div>
                        <!-- 五小牛 -->
                        <div v-else-if="tab.typeId == 13"
                            class="text-[0.563rem] font-[600] leading-[0.75rem] flex flex-col items-center justify-start text-center">
                            <template v-if="locale == 'cn'">
                                <div>五</div>
                                <div>小</div>
                            </template>
                            <template v-else>
                                <div>5</div>
                                <IconSvgUse use="icon-small-green" size="1rem" />
                            </template>
                        </div>
                        <!-- 普通牌型 -->
                        <div class="flex items-center justify-center" v-else>
                            <IconSvgUse v-if="tab.typeId == 0" use="icon-cow-white30"
                                size="1rem" />
                            <IconSvgUse v-else use="icon-cow-white100" size="1rem" />
                            <CanvasText :text="tab.type" :baseFontSize="locale == 'cn' ? 12 * scaleRatio : 9 * scaleRatio" color="#ffffff" />
                        </div>
                    </div>
                </div>
                <!-- 区域名称 -->
                <div class="tabs-btn" :class="'tabs-btn' + j">
                    <span class="text-[#FFFFFF] font-[700]">{{ locale == 'cn' ? table.nameCn : table.name }}</span>
                    <span class="text-[#FFFFFFB2] font-[500]">{{ getAllPlayersTotalValue(table.name) }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import PokerCard from './PokerCard.vue';
import CanvasText from './CanvasText.vue';
import { ref } from 'vue';
import cardAnimation from '../ts/cardAnimation';
import { useI18n } from 'vue-i18n';
import { getBettingResultClass, getHandTypeMultiplier } from '../ts/gameTps';

// 导入卡牌动画模块的所有功能
const {
    setAreaCardRef,
    fullDeck,
} = cardAnimation;

// 获取当前语言
const { locale, t } = useI18n();

// 组件属性 - 必须在使用前定义
const props = defineProps({
    areaTotalValues: {
        type: Object,
        default: () => ({})
    },
    scaleRatio: {
        type: Number,
        default: 1
    },
    allPlayersTotalValues: {
        type: Object,
        default: () => ({})
    },
    // 添加IndoorHeader组件引用作为props
    indoorHeaderRef: {
        type: Object,
        default: null
    },
    sectorCards: {
        type: Object,
        default: {}
    },
    tables: {
        type: Array as () => Array<{ name: string, nameCn: string, id?: string, disabled?: boolean }>,
        default: () => []
    },
    lastRoundResult: {
        type: Object,
        default: {}
    },
    // 获胜区域列表（用于高亮显示）
    winningSectors: {
        type: Array as () => string[] | null,
        default: null
    }
});
import bullNoBg from '../img/indoor/bull-no_bg.png'
import bull1Bg from '../img/indoor/bull1_bg.png'
import bullBullBg from '../img/indoor/bull-bull_bg.png'
import bullNBg from '../img/indoor/bull-n_bg.png'

// 根据牌型获取背景图片（多语言）
const getHandTypeBgImage = (handType: string): string => {
    if (!handType) return bull1Bg
    // 使用多语言文案进行比较，避免写死中文
    const noBullLabel = t('niuniu.niuType0') as string
    const bullBullLabel = t('niuniu.niuType10') as string

    if (handType === noBullLabel) return bullNoBg
    if (handType === bullBullLabel) return bullBullBg

    // 牛一到牛九：niuType1 ~ niuType9
    const bullNLabels: string[] = []
    for (let i = 1; i <= 9; i++) {
        bullNLabels.push(t(`niuniu.niuType${i}`) as string)
    }

    if (bullNLabels.includes(handType)) return bullNBg

    return bull1Bg // 默认
}

// 获取区域总下注值（当前玩家）- 用于统计浮层
const getAreaTotalValue = (areaName: string): number => {
    // areaName 已经是拼音ID，直接使用
    const value = props.areaTotalValues?.[areaName] || 0;
    return value;
};

// 获取区域总下注值（所有玩家）- 用于底部显示
const getAllPlayersTotalValue = (areaName: string): number => {
    // areaName 已经是拼音ID，直接使用
    const value = props.allPlayersTotalValues?.[areaName] || 0;
    return value;
};
// 定义组件事件
const emit = defineEmits<{
    'area-clicked': [areaId: string]
    'cards-revealed': [winningArea: string, handTypes: Record<string, string>]
}>()

const isFaceUpProp = ref(false)
// 各区域牌型结果 - 初始化为空对象
const handTypes: any = ref({
    'tian': '',
    'di': '',
    'xuan': '',
    'huang': '',
    'banker': ''
})

// 各区域实际倍率 - 存储服务器返回的倍率
const multipliers: any = ref({
    'tian': 1,
    'di': 1,
    'xuan': 1,
    'huang': 1
})
/**
 * 处理区域点击事件
 */
const handleAreaClick = (areaId: string) => {
    emit('area-clicked', areaId)
}

/**
 * 重置所有区域的牌型结果
 * 用于在新一轮开始前清空上一轮的结果显示
 */
const resetHandTypes = () => {
    handTypes.value = {}
    multipliers.value = {}
}

/**
 * 重置卡牌引用和状态
 * 在每局游戏结束后清空所有卡牌状态，确保新一局发牌动画与初始局相同
 */
const resetCardRefs = () => {
    // 重置卡牌引用，调用cardAnimation中的方法
    if (cardAnimation.clearCardRefs) {
        cardAnimation.clearCardRefs()
    } else {
        // 如果方法不存在，使用兼容方式重置
        console.warn('无法使用clearCardRefs方法，使用兼容方式重置')
    }

    // 重置牌型结果
    resetHandTypes()
}

/**
 * 设置特定区域的牌型结果和倍率
 * @param area 区域ID
 * @param name 牌型名称
 * @param type 牌型类型
 * @param multiplier 实际倍率（可选，来自服务器）
 */
const setHandType = (area: string, name: string, type: number, multiplier?: number) => {
    // 使用Vue的响应式更新方式确保视图更新
    const newHandTypes = { ...handTypes.value }
    newHandTypes[area] = name  // 存储牌型名称
    handTypes.value = newHandTypes

    // 如果提供了倍率，则更新倍率
    if (multiplier !== undefined) {
        const newMultipliers = { ...multipliers.value }
        newMultipliers[area] = multiplier
        multipliers.value = newMultipliers
    }
}

// 暴露给父组件的方法和数据
defineExpose({
    fullDeck,
    resetHandTypes,
    resetCardRefs, // 重置卡牌引用的方法
    collectCards: cardAnimation.collectCards, // 卡牌回收函数
    setHandType, // 设置牌型结果的方法
    handTypes, // 暴露handTypes状态便于展示
    multipliers // 暴露multipliers状态
});
</script>

<style scoped lang="scss">
.hall-cover {
    // 从 .main-box 合并的样式
    flex: 1;
    min-height: 0;
    width: 100%;
    scrollbar-gutter: stable;
    scrollbar-width: thin;
    scrollbar-color: var(--color_grey-40) transparent;
    
    // 原有布局样式
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    align-content: center;
    
    // 滚动条样式
    &::-webkit-scrollbar {
        width: 0.25rem;
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-thumb {
        background: var(--color_grey-40);
        border-radius: 0.125rem;
    }

    .hall-item {
        position: relative;
        /* 为伪元素定位做准备 */
        width: calc((100% - 5.75rem) / 2);
        height: 11.125rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        border-radius: 1.875rem;
        /* 🔧 移除 z-index，避免创建独立堆叠上下文，让子元素参与根堆叠上下文 */
        /* 这样飞行筹码可以在 .pocker(z-index:1) 和 .betting-result(z-index:66) 之间 */
        background: #00B5A033;
        cursor: pointer;
        transition: transform 0.3s ease, background 0.3s ease, box-shadow 0.3s ease;
        padding: 0.313rem 0 0.125rem;

        &:hover {
            transform: scale(1.02);
            background: #00B5A055;
        }

        /* 默认透明边框，防止高亮消失时闪白 */
        border: 1.5px solid transparent;

        /* 获胜区域高亮样式 - 闪烁效果 */
        &.hall-item-winning {
            border-color: rgba(255, 200, 100, 0.6);
            background: #FF883380;
            animation: winning-blink 2s ease-in-out infinite;
        }

        @keyframes winning-blink {

            0%,
            100% {
                box-shadow: 0 0 1.25rem rgba(255, 236, 67, 0.8),
                    0 0 0.625rem rgba(255, 157, 77, 0.6),
                    inset 0 0 0.938rem rgba(255, 136, 51, 0.3);
            }

            50% {
                box-shadow: 0 0 0.375rem rgba(255, 236, 67, 0.3),
                    0 0 0.188rem rgba(255, 157, 77, 0.2),
                    inset 0 0 0.313rem rgba(255, 136, 51, 0.15);
            }
        }

        &:active {
            transform: scale(0.98);
        }
    }
    .hall-item:nth-of-type(2n){
        margin-left: 1rem;
    }
    .hall-item:nth-of-type(2n+1){
        margin-right: 1rem;
    }

    .hall-item:nth-of-type(1){
        margin-bottom: 2rem;
    }
    .hall-item:nth-of-type(2){
        margin-bottom: 2rem;
    }

    /* 渐变边框伪元素 */
    .hall-item::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border: 0.063rem solid transparent;
        border-radius: inherit;
        /* 如果需要圆角 */
        background: linear-gradient(153.74deg, rgba(61, 255, 64, 0.5) 16.52%, rgba(61, 87, 255, 0.5) 113.65%) border-box;
        -webkit-mask:
            linear-gradient(#fff 0 0) padding-box,
            linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask:
            linear-gradient(#fff 0 0) padding-box,
            linear-gradient(#fff 0 0);
        mask-composite: exclude;
        pointer-events: none;
    }
}

.pocker {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    position: relative;
    height: 3.125rem;
    /* 给扑克牌区域一个固定高度 */
    /* 确保扑克牌容器居中 */
    margin: 0 auto;
    z-index: 1;
    /* Lower z-index to ensure betting-result appears above */

    /* 同时支持img元素和PokerCard组件 */
    img,
    :deep(.card) {
        position: absolute;
        transform: translateX(-50%) translateZ(0);
        /* 以卡牌中心为基准 + GPU加速 */
        // box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.3);
        /* 添加阴影效果 */
        border-radius: 0.375rem;
        /* 添加圆角 */
        overflow: hidden;
        will-change: transform, opacity;
        backface-visibility: hidden;
        -webkit-backface-visibility: hidden;
        
        :deep(.icon-bottom){
            height: 0.938rem;
            width: 0.938rem;
            bottom: 0.25rem;
        }
    }

    /* 卡牌位置样式 - 直接为PokerCard组件定位 */
    .pocker-img0 {
        left: calc(50% - 3.125rem);
        /* 左侧第二张 */
    }

    .pocker-img1 {
        left: calc(50% - 1.563rem);
        /* 左侧第一张 */
    }

    .pocker-img2 {
        left: 50%;
        /* 中间 */
    }

    .pocker-img3 {
        left: calc(50% + 1.563rem);
        /* 右侧第一张 */
    }

    .pocker-img4 {
        left: calc(50% + 3.125rem);
        /* 右侧第二张 */
    }
}

.tabs {
    display: flex;
    align-items: center;
    justify-content: space-around;
    gap: 0.188rem;
    border-radius: 12px;
    padding: 0.25rem 0.375rem;
    background: #0D131C;
    border: 0.031rem solid #2A3546;

    .tabs-item {
        width: 1.25rem;
        height: 1.875rem;
        // padding: 0.313rem 0.188rem;
        box-sizing: content-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        border-radius: 6px;
        border: 0.031rem solid var(--betcorgi-bg006_2A3546, #2A3546);
        background: var(--betcorgi-bg006_2A3546, #2A3546);

        .text {
            color: white;
            font-weight: 600;
            font-size: 0.625rem;
            line-height: 0.625rem;

        }
    }

    .tabs-item-active {
        border: 0.063rem solid var(--cow-004, #006970);
        background: var(--cow-003, #00B768);
    }
}

.tabs-btn {
    margin: 0 auto;
    width: 4.375rem;
    height: 1.25rem;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.188rem;
    font-size: 0.75rem;
    line-height: 0.75rem;
}

.tabs-btn0 {
    background-image: url(../img/indoor/rectangle1.png);
}

.tabs-btn1 {
    background-image: url(../img/indoor/rectangle2.png);
}

.tabs-btn2 {
    background-image: url(../img/indoor/rectangle3.png);
}

.tabs-btn3 {
    background-image: url(../img/indoor/rectangle4.png);
}

.betting-area {
    width: 100%;
    height: 3.75rem;
    padding: 0px 0.625rem;
    position: relative;
}

.betting-area-stats {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.6);
    border-radius: 0.5rem;
    padding: 0.5rem 0.625rem;
    color: white;
    line-height: 0.75rem;
    letter-spacing: 0.031rem;
    font-weight: 800;
    font-size: 0.75rem;
    z-index: 66;
    pointer-events: none;
    border: 0.063rem solid rgba(255, 215, 0, 0.5);
}

/* 牌型背景雾图 - 在右侧下层 */
.hand-type-bg-fog {
    width: 5.125rem;
    height: 4.5rem;
    position: absolute;
    bottom: -1.375rem;
    right: -1.25rem;
    z-index: -1;
    pointer-events: none;
}

.betting-result {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 888;  /* 66 → 100，确保始终在筹码(z-index:3)之上 */

    /* 确保动画流畅 */
    will-change: transform, opacity;

    .betting-result-content {
        height: 2.563rem;
        width: fit-content;
        min-width: 7.5rem;
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.063rem;
    }

    .result {
        font-weight: 600;
        font-size: 1.25rem;
        line-height: 1.5rem;
        letter-spacing: 0;
        color: white;
        display: flex;
        flex-wrap: nowrap;
    }

    .multiple {
        width: auto;
        height: 1.375rem;
        background-repeat: no-repeat;
        background-size: cover;
        padding: 0.188rem;
        font-weight: 600;
        font-size: 0.75rem;
        line-height: 0.75rem;
        letter-spacing: 0.031rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}

/* 开奖结果向下弹跳+放大回弹动画 */
.betting-result-slide-enter-active {
    animation: betting-result-bounce 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.betting-result-slide-leave-active {
    animation: betting-result-fade-out 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes betting-result-bounce {
    0% {
        transform: translate(-50%, calc(-50% - 1.875rem)) scale(0.3);
        opacity: 0;
    }

    60% {
        transform: translate(-50%, -50%) scale(1.08);
        opacity: 1;
    }

    100% {
        transform: translate(-50%, -50%) scale(1);
        opacity: 1;
    }
}

@keyframes betting-result-fade-out {
    0% {
        transform: translate(-50%, -50%) scale(1);
        opacity: 1;
    }

    100% {
        transform: translate(-50%, calc(-50% - 1.25rem)) scale(0.8);
        opacity: 0;
    }
}

.betting-result0 {
    background-image: url(../img/indoor/bull-no.webp);
}

.betting-result1 {
    background-image: url(../img/indoor/bull1.webp);

    .multiple {
        background-image: url(../img/indoor/bg1.png);
    }
}

.betting-result2 {
    background-image: url(../img/indoor/bull-n.webp);

    .result {
        text-shadow:
            0.063rem 0.063rem 0 #FF4D00,
            /* 右下橙色边缘 */
            -0.063rem -0.063rem 0 #6740FF;
        /* 左上紫色边缘 */
    }

    .multiple {
        background-image: url(../img/indoor/bg2.png);
    }
}

.betting-result3 {
    background-image: url(../img/indoor/bull-bull.webp);

    .result {
        text-shadow:
            -0.063rem -0.063rem 0 #FF4D00,
            /* 左上 */
            0.063rem -0.063rem 0 #FF4D00,
            /* 右上 */
            -0.063rem 0.063rem 0 #FF4D00,
            /* 左下 */
            0.063rem 0.063rem 0 #FF4D00;
        /* 右下 */
    }

    .multiple {
        background-image: url(../img/indoor/bg3.png);
    }
}

/* 在长屏幕时高度自动增加，只在高度超过 718px 时生效 */
@media (min-height: 812px) {
    .hall-cover {
        .hall-item {
            width: calc((100% - 2.563rem) / 2);
        }
        .hall-item:nth-of-type(2n){
            margin-left: 0.313rem;
        }
        .hall-item:nth-of-type(2n+1){
            margin-right: 0.313rem;
        }
    }
    

    /* 针对居中场景的动画关键帧覆盖 */
    @keyframes betting-result-bounce {
        0% {
            transform: translate(-50%, calc(-50% - 1.875rem)) scale(0.3);
            opacity: 0;
        }

        60% {
            transform: translate(-50%, -50%) scale(1.08);
            opacity: 1;
        }

        100% {
            transform: translate(-50%, -50%) scale(1);
            opacity: 1;
        }
    }

    @keyframes betting-result-fade-out {
        0% {
            transform: translate(-50%, -50%) scale(1);
            opacity: 1;
        }

        100% {
            transform: translate(-50%, calc(-50% - 1.25rem)) scale(0.8);
            opacity: 0;
        }
    }
}
</style>
